// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_REVIEW_TESTINGS_HEADER = "Podrobn\u00e9 recenze";
export const WIKI_REVIEW_TESTINGS_MORE = "V\u0161echny podrobn\u00e9 recenze...";
